export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11161.4c5c81c1.jpg";